<template>
  <div class="item-modal">
    <form action="" @submit.prevent="submitItemData">
      <div class="card-body">
        <div class="col-md-12" v-html="message"/>

        <div class="col-md-12" v-html="content" />

        <table-component
          ref="table"
          :show-filter="false"
          :data="attachments"
          table-class="table"
        >
          <table-column
            :label="$tc('documents.documentType', 2)"
            show="documentType.name"
          />
          <table-column
            :label="$t('documents.document')"
            show="name"
          />
          <table-column
            :sortable="false"
            :filterable="false"
            cell-class="action-dropdown"
          >
            <template slot-scope="row">
              <span> {{ $t('customers.action') }} </span>
              <v-dropdown>
                <a slot="activator" href="#"><dot-icon /></a>
                <v-dropdown-item>
                  <div class="dropdown-item">
                    <a v-if="row.path" :href="row.path" target="_blank" >
                      <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                      {{ $t('general.view') }}
                    </a>
                  </div>
                </v-dropdown-item>
              </v-dropdown>
            </template>
          </table-column>
        </table-component>
      </div>

      <div class="card-footer justify-content-between align-items-center">
        <div>
          <div class="custom-control custom-checkbox">
            <input id="confirm" v-model="confirmContract" type="checkbox" class="custom-control-input">
            <label for="confirm" class="custom-control-label">Confirm Contract</label>
          </div>
          <div v-if="$v.confirmContract.$error">
            <span v-if="!$v.confirmContract.required" class="form-group__message text-danger">{{
            $tc('validation.required') }}</span>
          </div>
        </div>
        <div class="d-flex">
          <base-button :outline="true" class="mr-3" color="theme" type="button" @click="closeItemModal">
            {{ $t('general.cancel') }}
          </base-button>
          <base-button v-if="isEdit" :loading="isLoading" color="theme" @click="submitItemData">
            {{ name }}
          </base-button>
          <base-button v-else :loading="isLoading" icon="save" color="theme" type="submit">
            {{ $t('general.save') }}
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      modalName: null,
      islamicForm: false,
      isEdit: false,
      isLoading: false,
      message: null,
      row: null,
      attachments: [],
      confirmContract: null,
      content: null,
      name: null
    }
  },
  validations: {
    confirmContract: {
      required
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData'
    ])
  },
  ...mapGetters('currency', [
    'defaultCurrency',
    'defaultCurrencyForInput'
  ]),
  watch: {
    modalDataID () {
      this.isEdit = true
      this.setData()
    }
  },
  created () {
    if (this.modalDataID) {
      this.isEdit = true
    }

    if (this.isEdit) {

    }
  },
  mounted () {
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'openModal',
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('OfferToSell', [
      'markAsOffer',
      'markAsAccept',
      'markAsNoticeOfNotice',
      'markAsAgentAppoint',
      'markAsAgencyAccepted',
      'markAsAgencyRejected',
      'markAsSaleConfirmed'
    ]),
    resetFormData () {
      this.message = null
      this.attachments = null
      this.content = null
      this.name = null
      this.confirmContract = null
      this.supplierName = null
      this.funderName = null
      this.itemList = null
    },
    async setData () {
      if (this.modalData['name'] === 'Offer Accepted') {
        this.name = 'Accept Offer'
      } else {
        this.name = this.modalData['name']
      }
      this.supplierName = this.modalData['supplierName']
      this.funderName = this.modalData['funderName']
      this.message = this.modalData['message']
      this.islamicForm = this.modalData['form']
      this.modalName = this.modalData['conditionName']
      this.attachments = this.modalData['items']
      this.content = this.modalData['content']
    },
    async submitItemData () {
      // Prevent multiple simultaneous submissions
      if (this.isLoading) {
        return false
      }

      this.$v.confirmContract.$touch()
      if (this.$v.$invalid) {
        return false
      }

      // Trigger browser validation for dynamically injected required inputs
      const formEl = this.$el.querySelector('form')
      if (formEl && !formEl.checkValidity()) {
        formEl.reportValidity()
        return false
      }

      // Set loading state to prevent duplicate submissions
      this.isLoading = true

      const inputs = document.querySelectorAll('.card-body input.form-control')

      const formDataArray = []
      inputs.forEach((input) => {
        let value = input.value

        // Format date from YYYY-MM-DD to DD/MM/YYYY
        if ((input.getAttribute('name') === 'image_uploaded_date' || input.getAttribute('name') === 'Image_uploaded_date') && input.type === 'date') {
          if (value) {
            const dateObj = new Date(value)
            const day = String(dateObj.getDate()).padStart(2, '0')
            const month = String(dateObj.getMonth() + 1).padStart(2, '0')
            const year = dateObj.getFullYear()
            value = `${day}/${month}/${year}`
          }
        }

        // Format time from HH:MM to 12-hour format with am/pm
        if ((input.getAttribute('name') === 'image_uploaded_time' || input.getAttribute('name') === 'Image_uploaded_time') && input.type === 'time') {
          if (value) {
            const [hours, minutes] = value.split(':')
            const hour = parseInt(hours)
            const ampm = hour >= 12 ? 'pm' : 'am'
            const hour12 = hour % 12 || 12
            value = `${hour12}:${minutes} ${ampm}`
          }
        }

        formDataArray.push({name: input.getAttribute('name'), value: value})
      })

      const data = {
        islamic_finance_id: this.modalDataID,
        content_data: formDataArray
      }

      try {
        if (this.modalData['name'] === 'Offer Accepted') {
          let response = await this.markAsAccept(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_accepted_message'))
            this.modalData['nextStep'](this.modalData['row'])
          }
        } else if (this.modalData['name'] === 'Notice of Delivery') {
          let response = await this.markAsNoticeOfNotice(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_notice_delivery_message'))
            this.modalData['nextStep'](this.modalData['row'])
          }
        } else if (this.modalData['name'] === 'Documentation Complete') {
          let response = await this.markAsAgentAppoint(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_agent_appointment_message'))
          }
        } else if (this.modalData['name'] === 'Agency Pending') {
          let response = await this.markAsAgentAppoint(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_agent_appointment_message'))
          }
        } else if (this.modalData['name'] === 'Agency Accepted') {
          let response = await this.markAsAgencyAccepted(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_agency_accepted_message'))
          }
        } else if (this.modalData['name'] === 'Agency Rejected') {
          let response = await this.markAsAgencyRejected(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_agency_rejected_message'))
          }
        } else if (this.modalData['name'] === 'Confirmation of Sale') {
          let response = await this.markAsSaleConfirmed(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_sale_confirmed_message'))
          }
        } else {
          let response = await this.markAsOffer(data)
          if (response.data.success) {
            window.toastr['success'](this.$tc('islamic_finance.mark_as_offer_message'))
          }
        }
        this.closeItemModal()
      } catch (error) {
        console.error('Error submitting offer:', error)
        // Error handling - you may want to show an error toast here
      } finally {
        this.isLoading = false
      }
      return true
    },
    closeItemModal () {
      this.resetFormData()
      this.closeModal()
      this.resetModalData()
    }
  }
}
</script>
<style scoped>
.card-body{
  max-height: 80vh !important;
  overflow: auto !important;;
}
</style>
